import { DateTime } from 'luxon'

export class Event {
	public playerId: number
	public eventName: string
	public description: string | null
	public path: string | null
	public origin: {
		title: string | null
		advertName?: string | null
		announcementName?: string | null
		radioId?: number | null
		segmentId?: number | null
		segmentName?: string | null
	}
	public createdAt: DateTime
	public isTimeAssumed: boolean

	constructor(data: {
		playerId: number
		eventName: string
		description: string | null
		path: string | null
		origin: {
			title: string | null
			advertName?: string | null
			announcementName?: string | null
			radioId?: number | null
			segmentId?: number | null
			segmentName?: string | null
		}
		createdAt: DateTime
		isTimeAssumed: boolean
	}) {
		this.playerId = data.playerId
		this.eventName = data.eventName
		this.description = data.description
		this.path = data.path
		this.origin = data.origin
		this.createdAt = data.createdAt
		this.isTimeAssumed = data.isTimeAssumed
	}

	static create(data: Partial<Event>): Event {
		const defaultData = {
			playerId: 0,
			eventName: '',
			description: null,
			path: null,
			origin: {
				title: null,
			},
			createdAt: DateTime.now(),
			isTimeAssumed: false,
		}

		return new Event({
			...defaultData,
			...data,
		})
	}

	isPlayable(): boolean {
		return this.path !== null && this.path !== ''
	}
}
